module.exports = __webpack_public_path__ + "img/bander2.d92dddd0.png";